import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ClearIcon from "@mui/icons-material/Clear";
import { BackButton } from "../../Commons/BackAndForwardButton";

import Styled from "./CreateInvoiceStyles";
import TextStyles from "../../../../Constants/TextStyles";
import Colors from "../../../../Constants/Colors";
import { useLocation } from "react-router-dom";
import ProtectedRoute from "../../../auth/ProtectedRoute";
import InvoiceSetup from "./InvoiceSetup/InvoiceSetup";
import { invoiceActions } from "../../../../store/storage/invoiceSlice";
import SetupProject from "./SetupProject/SetupProject";
import SetupClient from "./ClientSetup/SetupClient";
import QuickSetup from "./QuickInvoice/QuickSetup";
import CreateClient from "./CreateClient/CreateClient";
import ReviewInvoice from "../ReviewInvoice/ReviewInvoice";
import SendInvoice from "../SendInvoice/SendInvoice";
import DiscardChangesModal from "../InvoiceModals/DiscardChangesModal";
import SelectInvoice from "./SelectInvoice/SelectInvoice";
import { saveInvoice } from "../../../../store/service/invoiceService";
import { message } from "antd";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";

import { Popover } from "antd";
import LoaderSpin from "../../Commons/LoaderSpin";
import { timeTrackingActions } from "../../../../store/storage/timetrackingSlice";
import useTimeTrackingTitle from "../../../../hooks/useTimeTrackingTitle";
import { ReactTooltip } from "../../Commons/ReactTooltip";
import { useAllowedToContinue } from "../../../../hooks/useAllowedToContinue";

const CreateInvoice = () => {
  useTimeTrackingTitle();

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedInvoiceData = useSelector(
    (state) => state.invoices.selectedInvoiceData
  );

  const createInvoiceMode = useSelector(
    (state) => state.invoices.createInvoiceMode
  );

  const { startActivityData } = useSelector(state => state.timeTracking);

  // modals
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);

  // select invoice
  const [openSaveInvoiceAs, setOpenInvoiceSaveAs] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isAllowedSave = useAllowedToContinue("invoices");

  const handleOpenSaveInvoiceAsChange = (newOpen) => {
    setOpenInvoiceSaveAs(newOpen);
  };

  const discardChangesHandler = () => {
    history.push("/db/invoices");
    dispatch(invoiceActions.selectedInvoiceResetAction());
  };

  const saveInvoiceHandler = (status) => {
    const Obj = {
      ...selectedInvoiceData,
      status: status,
    };
    setIsLoading(true);
    dispatch(saveInvoice(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setIsLoading(false);
        history.push("/db/invoices");
        dispatch(invoiceActions.selectedInvoiceResetAction());
        message.success(`${data.payload.message}`);
      } else {
        setIsLoading(false);
        message.error(`${data.error.message}!`);
      }
    });
  };

  const saveInvoiceAsContent = () => {
    return (
      <TextStyles.FontSize14px className={isAllowedSave ? '' : 'pe-none opacity-75'}>
        <Styled.List
          onClick={() => {
            setOpenInvoiceSaveAs(false);
            saveInvoiceHandler("Draft");
          }}
        >
          Save Draft
        </Styled.List>
        <Styled.List
          onClick={() => {
            setOpenInvoiceSaveAs(false);
            saveInvoiceHandler("Sent");
          }}
        >
          Save & Mark Sent
        </Styled.List>
      </TextStyles.FontSize14px>
    );
  };

  useEffect(() => {
    if (!startActivityData.start_time) return;

    const interval = setInterval(() => {
      dispatch(timeTrackingActions.updateTimer());
    }, 1000);

    return () => clearInterval(interval);
  }, [startActivityData.start_time]);

  return (
    <div
      style={{
        background: Colors.newBackgroundGrey,
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          background: Colors.white,
          zIndex: 200,
        }}
        className="fixed-top"
      >
        <div className="px-2 py-3">
          <TextStyles.FontSize14px
            className="d-none d-sm-flex"
            style={{
              position: "absolute",
              left: "0.75rem",
              top: "1.3rem",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ClearIcon
              onClick={() => {
                if (selectedInvoiceData || createInvoiceMode) {
                  setShowDiscardModal(true);
                  setConfirmDialog({
                    onConfirm: () => discardChangesHandler(),
                  });
                } else {
                  history.goBack();
                }
              }}
              sx={{
                fontSize: 24,
                color: Colors.font2,
                cursor: "pointer",
                opacity: 0.7,
                "&:hover": {
                  opacity: 1,
                },
              }}
            />
          </TextStyles.FontSize14px>
          <TextStyles.FontSize22px className="text-center font-weight-500">
            Create Invoice
          </TextStyles.FontSize22px>

          {!isAllowedSave && <ReactTooltip anchorId='save' content='Upgrade Plan' place='left' variant='grey' />}
          <TextStyles.FontSize14px
            id='save'
            className="d-none d-sm-flex"
            style={{
              position: "absolute",
              right: "1rem",
              top: "1rem",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            {selectedInvoiceData &&
              ((selectedInvoiceData.invoice_services &&
                selectedInvoiceData.invoice_services.length > 0) ||
                (selectedInvoiceData.line_item_services &&
                  selectedInvoiceData.line_item_services.length > 0)) && (
                <TextStyles.FontSize14px>
                  <Popover
                    placement="bottomRight"
                    // title={"Hello"}
                    content={saveInvoiceAsContent}
                    trigger="click"
                    open={openSaveInvoiceAs}
                    onOpenChange={handleOpenSaveInvoiceAsChange}
                  >
                    <Styled.DownloadButton opacity={isAllowedSave ? '' : '75%'}>
                      {isLoading ? (
                        <LoaderSpin />
                      ) : (
                        <div className="d-flex">
                          <span className="ps-2">Save</span>
                          <ArrowDropDownOutlinedIcon
                            sx={{
                              color: Colors.font2,
                              fontSize: 24,
                              transform: openSaveInvoiceAs
                                ? "rotate(180deg)"
                                : "",
                            }}
                          />
                        </div>
                      )}
                    </Styled.DownloadButton>
                  </Popover>
                </TextStyles.FontSize14px>
              )}
          </TextStyles.FontSize14px>
        </div>

        <div className="d-flex">
          <Styled.ProgressBar>
            <div
              className="col"
              style={{
                height: "100%",
                backgroundColor: Colors.primary,
                color: Colors.white,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              Setup
            </div>
            <div
              className="col"
              style={
                location &&
                (location.pathname === "/db/invoices/create/review" ||
                  location.pathname === "/db/invoices/create/send")
                  ? {
                      height: "100%",
                      backgroundColor: Colors.primary,
                      color: Colors.white,
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    }
                  : { justifyContent: "center", display: "flex" }
              }
            >
              Review
            </div>
            <div
              className="col"
              style={
                location && location.pathname === "/db/invoices/create/send"
                  ? {
                      height: "100%",
                      backgroundColor: Colors.primary,
                      color: Colors.white,
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                    }
                  : { justifyContent: "center", display: "flex" }
              }
            >
              Send
            </div>
          </Styled.ProgressBar>
        </div>
      </div>

      <div style={{ paddingTop: 100 }}>
        {location && location.pathname !== "/db/invoices/create" && (
          <div
            style={{ position: "fixed", left: 20, top: "50vh", zIndex: 200 }}
            onClick={() => history.goBack()}
          >
            <BackButton />
          </div>
        )}

        {location && location.pathname === "/db/invoices/create" && (
          <ProtectedRoute
            path="/db/invoices/create"
            exact
            component={SelectInvoice}
          />
        )}
        {location && location.pathname === "/db/invoices/create/setup" && (
          <ProtectedRoute
            path="/db/invoices/create/setup"
            exact
            component={InvoiceSetup}
          />
        )}

        {location &&
          location.pathname === "/db/invoices/create/setupClient" && (
            <ProtectedRoute
              path="/db/invoices/create/setupClient"
              exact
              component={SetupClient}
            />
          )}
        {location &&
          location.pathname === "/db/invoices/create/setupProject" && (
            <ProtectedRoute
              path="/db/invoices/create/setupProject"
              exact
              component={SetupProject}
            />
          )}
        {location &&
          location.pathname === "/db/invoices/create/quickInvoice" && (
            <ProtectedRoute
              path="/db/invoices/create/quickInvoice"
              exact
              component={QuickSetup}
            />
          )}
        {location &&
          location.pathname === "/db/invoices/create/createClient" && (
            <ProtectedRoute
              path="/db/invoices/create/createClient"
              exact
              component={CreateClient}
            />
          )}
        {location && location.pathname === "/db/invoices/create/review" && (
          <ProtectedRoute
            path="/db/invoices/create/review"
            exact
            component={ReviewInvoice}
          />
        )}
        {location && location.pathname === "/db/invoices/create/send" && (
          <ProtectedRoute
            path="/db/invoices/create/send"
            exact
            component={SendInvoice}
          />
        )}
        {showDiscardModal && (
          <DiscardChangesModal
            show={showDiscardModal}
            confirmDialog={confirmDialog}
            handleClose={() => setShowDiscardModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default CreateInvoice;
